import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getResendVerificationCode } from '../../utils/keys';
export const useResendVerificationCode = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const resendVerificationCodeKey = getResendVerificationCode();
    return useMutation(() => client.auth.resendVerification(), {
        mutationKey: resendVerificationCodeKey,
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useResendVerificationCode.js.map